import { useEffect, useState } from "preact/hooks"

/**
 * The value, held back until it stops changing for `delay_ms`.
 *
 * For search-as-you-type against `swr`: debounce the value that goes into the SWR *key* rather than
 * the fetch itself, so a keystroke doesn't become a request but swr still owns caching, dedup and
 * revalidation. Debouncing a hand-rolled fetch instead is what this replaces.
 */
export function use_debounced_value<T>(value: T, delay_ms: number): T {
  const [debounced, set_debounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => set_debounced(value), delay_ms)
    return () => clearTimeout(timer)
  }, [value, delay_ms])

  return debounced
}
